import { z } from 'zod';
/**
 * Tape-measure readings (M-113..M-116).
 *
 * Stored in millimetres and shown in centimetres. Rule 3: the base unit is
 * kept and the conversion happens at the edge, which here is the screen.
 */
export const bodySiteSchema = z.enum([
    'waist',
    'hips',
    'neck',
    'chest',
    'bicep_left',
    'bicep_right',
    'thigh_left',
    'thigh_right',
]);
/** In the order somebody would work down a body, not alphabetically. */
export const BODY_SITES = [
    'neck',
    'chest',
    'bicep_left',
    'bicep_right',
    'waist',
    'hips',
    'thigh_left',
    'thigh_right',
];
export const BODY_SITE_LABELS = {
    neck: 'Neck',
    chest: 'Chest',
    bicep_left: 'Left bicep',
    bicep_right: 'Right bicep',
    waist: 'Waist',
    hips: 'Hips',
    thigh_left: 'Left thigh',
    thigh_right: 'Right thigh',
};
export const bodyMeasurementSchema = z.object({
    date: z.string().date(),
    site: bodySiteSchema,
    /** Millimetres, as stored. The screen divides by ten. */
    millimetres: z.number().int(),
    /** 'tape' when the device reported it, 'manual' when somebody typed it. */
    source: z.string(),
    updatedAt: z.string(),
});
export const saveBodyMeasurementSchema = z.object({
    date: z.string().date(),
    site: bodySiteSchema,
    /**
     * A centimetre either side of anything a tape can reach is a typo, not a
     * measurement, and no part of a body is a centimetre around.
     */
    millimetres: z.number().int().min(10).max(2000),
    source: z.enum(['tape', 'manual']).default('manual'),
});
//# sourceMappingURL=body.js.map